import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * Roles del sistema (4):
 * - superadmin: acceso total + gestión de usuarios
 * - admin: todo excepto usuarios
 * - legales: contratos y ficha de jugadores
 * - scout: seguimientos, jugadores, solicitar materiales
 */

const LEGACY_MAP = {
  gerencia: 'admin',
  intendente: 'admin',
  coach: 'scout',
  administracion: 'admin',
  user: 'admin',
};

const normalize = (r) => (r ? (LEGACY_MAP[r] || r) : null);

const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = null }) => {
  const { user, loading, role } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles.length === 0) return children;

  const effectiveRole = normalize(role);
  const normalizedAllowed = allowedRoles.map(normalize);

  // superadmin siempre puede
  if (effectiveRole === 'superadmin' || normalizedAllowed.includes(effectiveRole)) {
    return children;
  }

  return <Navigate to={redirectTo || getDefaultRouteForRole(effectiveRole)} replace />;
};

export const getDefaultRouteForRole = (role) => {
  const r = normalize(role);
  switch (r) {
    case 'scout':
      return '/seguimiento';
    case 'legales':
      return '/players';
    case 'admin':
    case 'superadmin':
    default:
      return '/';
  }
};

export default ProtectedRoute;
